import { 
    setUser,
    setClient,
    setSecurityRoles,
    setContentGroups,
    setWebsocket,
    requestFullEvents,
    requestFullEvent,
    requestSlimEvents,
    requestEncoders,
    requestEvents,
    requestEventLogItems,
    requestEventAnalytics,
    pageChange
} from './data/actions'

import {
    sendRequest,
    requestCategories
} from './requests/actions'

import {
    createAlert,
    closeAlert
} from './alerts/actions'

import { 
    setEventsFilter,
    setEventViewType,
    setEventsExpanded
} from './events/actions'

export default {
    user: {
        setUser,
        setClient,
        setSecurityRoles,
        setContentGroups
    },
    data: {
        setWebsocket,
        requestFullEvents,
        requestFullEvent,
        requestSlimEvents,
        requestEvents,
        requestEventLogItems,
        requestEncoders,
        requestEventAnalytics,
        pageChange
    },
    request: {
        sendRequest,
        requestCategories
    },
    events: {
        setEventsFilter,
        setEventViewType,
        setEventsExpanded
    },
    alerts: {
        createAlert,
        closeAlert
    }
}
